var exports = {
  "LL": "LexicalMessageComposer.module__editable___UmlHLU",
  "h5": "LexicalMessageComposer.module__richInputHost___UmlHLU",
  "I8": "LexicalMessageComposer.module__formSize___UmlHLU",
  "FY": "LexicalMessageComposer.module__paragraph___UmlHLU",
  "qf": "LexicalMessageComposer.module__placeholder___UmlHLU",
  "xL": "LexicalMessageComposer.module__marker___UmlHLU",
  "_u": "LexicalMessageComposer.module__blockquoteLine___UmlHLU",
  "iU": "LexicalMessageComposer.module__blockquoteMarker___UmlHLU",
  "Cr": "LexicalMessageComposer.module__bold___UmlHLU",
  "TN": "LexicalMessageComposer.module__italic___UmlHLU",
  "V1": "LexicalMessageComposer.module__underline___UmlHLU",
  "ZN": "LexicalMessageComposer.module__strike___UmlHLU",
  "aY": "LexicalMessageComposer.module__code___UmlHLU",
  "Po": "LexicalMessageComposer.module__mentionHost___UmlHLU",
  "ZJ": "LexicalMessageComposer.module__emojiHost___UmlHLU",
  "G5": "LexicalMessageComposer.module__command___UmlHLU",
  "Gx": "LexicalMessageComposer.module__slashSlot___UmlHLU",
  "Pe": "LexicalMessageComposer.module__slashSlotPlaceholder___UmlHLU",
  "ZW": "LexicalMessageComposer.module__slashSlotSeparator___UmlHLU",
  "Q$": "LexicalMessageComposer.module__optionalHint___UmlHLU",
};

module.exports = exports;
